import { useCommonStore } from "@/stores";
import styles from "./index.module.scss";
import {
  SourceImgUploaderMobile,
  ChooseExpTemp,
  GenerateButton,
  Navigation,
} from "@/components";
import { Suspense, lazy } from "react";

const Generating = lazy(() => import("@/components/generating"));
const MoreExpTempModal = lazy(() => import("@/components/more-exp-temp-modal"));

const MainMobile = () => {
  const generating = useCommonStore(state => state.generating);
  const moreExpTempVisible = useCommonStore(state => state.moreExpTempVisible);
  return (
    <div
      className={styles["main_mobile"]}
    >
      <div
        className={styles["uploader_area"]}
      >
        <SourceImgUploaderMobile
        ></SourceImgUploaderMobile>

        {generating && (
          <Suspense>
            <Generating></Generating>
          </Suspense>
        )}
      </div>

      <div
        className={styles["wrapper"]}
      >
        <ChooseExpTemp
        ></ChooseExpTemp>

        <div
          className={styles["generate_button_row"]}
        >
          <GenerateButton
          ></GenerateButton>
        </div>
      </div>

      <Navigation
      ></Navigation>

      {moreExpTempVisible && (
        <Suspense>
          <MoreExpTempModal></MoreExpTempModal>
        </Suspense>
      )}
    </div>
  )
}

export default MainMobile;